// 9fbef606107a605d69c0edbcd8029e5d
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import MyProfile from '../views/MyProfile.view';
import {
  getUserContactInfo,
  getMailingAddress,
  getUserBirthday,
  getAnswersList,
  getProfileCompletion,
  getPercentageIncrement,
  getDefaultStore,
  getUserFullName,
  getUserEmail,
  getUserPhoneNumber,
  getAirmilesDetails,
  getMyPlaceNumber,
  getProfileInfoTileData,
  getChildren,
  getPhoneCountryCode,
} from '../../User/container/User.selectors';

import { getSuccess } from './MyProfile.selectors';
import { updateProfileSuccess } from './MyProfile.actions';
import {
  getIsInternationalPhoneNumber,
  getNewGlobalErrorMessage,
} from '../../../../../reduxStore/selectors/session.selectors';
import { setGlobalError } from '../../../../common/molecules/GlobalErrorComponent/container/GlobalErrorComponent.actions';
import { getLabelFromCopyOrFromTranslation } from '../../../../../utils/labels/labelUtilty';
import {
  ACCOUNT_PROFILE,
  lblProfileSuccessMsg,
  ProfileInformationLabels,
} from '../views/MyProfile.labels';
import { getErrorVisibleState } from '../../../../common/molecules/GlobalErrorComponent/container/GlobalErrorComponent.selectors';

const getMyProfileInfoLabels = (labels) => {
  return (labels && labels.profile) || {};
};

export class MyProfileContainer extends PureComponent {
  componentWillUnmount() {
    const { messageSateChangeAction } = this.props;
    messageSateChangeAction(null);
  }

  componentDidUpdate() {
    const {
      setGlobalErrorAction,
      successMessage,
      messageSateChangeAction,
      newGlobalErrorMessageEnabled,
    } = this.props;
    if (successMessage && newGlobalErrorMessageEnabled) {
      messageSateChangeAction(null);
      const successMsg = getLabelFromCopyOrFromTranslation(
        `${ACCOUNT_PROFILE}.${lblProfileSuccessMsg}`,
        ProfileInformationLabels
      );
      setGlobalErrorAction({ message: successMsg, type: 'success' });
    }
  }

  render() {
    const { labels, ...otherProps } = this.props;
    const profileInfoLabels = getMyProfileInfoLabels(labels);
    return <MyProfile labelsObj={labels} labels={profileInfoLabels} {...otherProps} />;
  }
}

MyProfileContainer.propTypes = {
  labels: PropTypes.shape({}),
  messageSateChangeAction: PropTypes.func.isRequired,
};

MyProfileContainer.defaultProps = {
  labels: {},
};

const mapStateToProps = (state) => {
  return {
    personalInformation: getUserContactInfo(state),
    mailingAddress: getMailingAddress(state),
    userBirthday: getUserBirthday(state),
    userSurvey: getAnswersList(state),
    profileCompletion: getProfileCompletion(state),
    percentageIncrement: getPercentageIncrement(state),
    defaultStore: getDefaultStore(state),
    successMessage: getSuccess(state),
    userFullName: getUserFullName(state),
    userEmail: getUserEmail(state),
    userPhoneNumber: getUserPhoneNumber(state),
    airMiles: getAirmilesDetails(state),
    myPlaceNumber: getMyPlaceNumber(state),
    profileInfoTile: getProfileInfoTileData(state),
    childrenBirthdays: getChildren(state),
    phoneCountryCode: getPhoneCountryCode(state),
    isInternationalPhoneNumberEnabled: getIsInternationalPhoneNumber(state),
    newGlobalErrorMessageEnabled: getNewGlobalErrorMessage(state),
    notificationVisible: getErrorVisibleState(state),
  };
};

export const mapDispatchToProps = (dispatch) => ({
  messageSateChangeAction: (payload) => {
    dispatch(updateProfileSuccess(payload));
  },
  setGlobalErrorAction: (payload) => {
    dispatch(setGlobalError(payload));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(MyProfileContainer);
